var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99988 5C5.99988 4.44772 6.4476 4 6.99988 4H16.9999C17.5522 4 17.9999 4.44772 17.9999 5C17.9999 5.55228 17.5522 6 16.9999 6H6.99988C6.4476 6 5.99988 5.55228 5.99988 5ZM4.31484 10C3.1316 10 2.20703 11.0216 2.32477 12.199L2.72477 16.199C2.82701 17.2214 3.68734 18 4.71484 18H7.75724C8.28767 18 8.79638 17.7893 9.17145 17.4142L9.87856 16.7071C11.0501 15.5355 12.9496 15.5355 14.1212 16.7071L14.8283 17.4142C15.2034 17.7893 15.7121 18 16.2425 18H19.2849C20.3124 18 21.1728 17.2214 21.275 16.199L21.675 12.199C21.7927 11.0216 20.8682 10 19.6849 10H4.31484ZM0.334694 12.398C0.0992197 10.0433 1.94835 8 4.31484 8H19.6849C22.0514 8 23.9005 10.0433 23.6651 12.398L23.2651 16.398C23.0606 18.4428 21.3399 20 19.2849 20H16.2425C15.1817 20 14.1642 19.5786 13.4141 18.8284L12.707 18.1213C12.3165 17.7308 11.6833 17.7308 11.2928 18.1213L10.5857 18.8284C9.83552 19.5786 8.81811 20 7.75724 20H4.71484C2.65984 20 0.939175 18.4428 0.734694 16.398L0.334694 12.398Z",
    fill: "#005C69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.f69539c4c98d418ba5019b78becea818.svg";
export { ForwardRef as ReactComponent };